import { FormEngineFormView, Skeleton } from '@gov-nx/component/web';
import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import { useEasyFormContext } from '@gov-nx/module/service';
import { ErrorStatusBanner, InfoBanner, LayoutGap } from '@gov-nx/ui/web';
import { RezaChangeFormSkeleton } from '../../../Reza/RezaChangeFormView/RezaChangeFormSkeleton';

export const EasyFormModalContent = () => {
	const {
		isFetching,
		isError,
		isNoData,
		onModalClose,
		name,
		anotation,
		...formEngineFormViewProps
	} = useEasyFormContext();
	const { Component, Global } = LocalizeNameSpaceTypes;
	const { t } = useLocale(Component);

	if (isFetching) {
		return (
			<LayoutGap>
				<Skeleton
					width="100%"
					height="24px"
				/>
				<RezaChangeFormSkeleton />
			</LayoutGap>
		);
	}

	if (isError) {
		return <ErrorStatusBanner code={Global} />;
	}

	if (isNoData) {
		return (
			<InfoBanner
				headline={t('stav.chyba.zadny-formular')}
				text={t('stav.chyba.zadny-formular-popis')}
			/>
		);
	}

	return (
		<LayoutGap>
			<p>{anotation}</p>
			<FormEngineFormView {...formEngineFormViewProps} />
		</LayoutGap>
	);
};
